const families = [

  { name: "Mor", url: "/collections/mor-plakat-1" },
  { name: "Far", url: "/collections/far-plakat-1" },

{ name: "Adoptivbarn", url: "/collections/adoptivbarn-plakater" },
  { name: "Adoptivbørn", url: "/collections/adoptivborn-plakater" },
  { name: "Adoptivsøster", url: "/collections/adoptivsoster-plakater" },
  { name: "Adoptivforældre", url: "/collections/adoptivforaeldre-plakater" },
  { name: "Adoptivsøskende", url: "/collections/adoptivsoskende-plakater" },
  { name: "Adoptivfamilie", url: "/collections/adoptivfamilie-plakater" },
  { name: "Adoptivfar", url: "/collections/adoptivfar-plakater" },
  { name: "Adoptivmor", url: "/collections/adoptivmor-plakater" },
  { name: "Adoptivdatter", url: "/collections/adoptivdatter-plakater" },
  { name: "Adoptivsøn", url: "/collections/adoptivson-plakater" },
  { name: "Adoptivbror", url: "/collections/adoptivbror-plakater" },
    { name: "Baby", url: "/collections/baby-plakater" },
  { name: "Barn", url: "/collections/plakater-til-barn" },
  { name: "Barnebarn", url: "/collections/barnebarn-plakater" },
  { name: "Barnepige", url: "/collections/barnepige-plakat" },
  { name: "Bedste", url: "/collections/bedste-plakat" },
  { name: "Bedstefar", url: "/collections/bedstefar-plakat" },
  { name: "Bedstemor", url: "/collections/bedstemor-plakat" },
  { name: "Bonusbarnebarn", url: "/collections/bonusbarnebarn" },
  { name: "Bonusbedste", url: "/collections/bonusbedste" },
  { name: "Bonusbror", url: "/collections/bonusbror" },
  { name: "Bonusdatter", url: "/collections/bonusdatter-plakater" },
  { name: "Bonusfar", url: "/collections/bonusfar-plakat" },
  { name: "Bonusmor", url: "/collections/bonusmor-plakat" },
  { name: "Bonussøn", url: "/collections/bonusson-plakat" },
  { name: "Bonussøster", url: "/collections/bonussoster-plakat" },
  { name: "Bonusbedsteforældre", url: "/collections/bonusbedsteforaeldre" },
  { name: "Bonusbørnebørn", url: "/collections/bonusborneborn" },
  { name: "Bonussøskende", url: "/collections/bonussoskende" },
  { name: "Bonusbørn", url: "/collections/bonusborn" },
  { name: "Bedste ven", url: "/collections/bedste-ven" },
  { name: "Bedste veninde", url: "/collections/bedste-veninde-plakater" },
  { name: "Bedsteforældre", url: "/collections/bedsteforaeldre-plakater" },
  { name: "Bonusfamilie", url: "/collections/bonusfamilie-plakater" },
  { name: "Brødre", url: "/collections/brodre-plakater" },
  { name: "Børn", url: "/collections/plakater-til-born" },
  { name: "Bror", url: "/collections/bror-plakat" },
  { name: "Brudepar", url: "/collections/brudepar-plakater" },
  { name: "Børnebørn", url: "/collections/borneborn-plakater" },
  { name: "Børnepasser", url: "/collections/bornepasser-plakater" },
  { name: "Datter", url: "/collections/datter-plakat" },
  { name: "Drengemor", url: "/collections/drengemor-plakater" },
  { name: "Dyrpasser", url: "/collections/dyrepasser" },
  { name: "Ekstrafar", url: "/collections/ekstrafar-plakater" },
  { name: "Ekstramor", url: "/collections/ekstramor-plakater" },
  { name: "Farbror", url: "/collections/farbror-plakater" },
  { name: "Farfar", url: "/collections/farfar-plakat" },
  { name: "Farmor", url: "/collections/farmor-plakat" },
  { name: "Faster", url: "/collections/faster-plakat" },
  { name: "Fætter", url: "/collections/faetter-plakater" },
  { name: "Gravid", url: "/collections/gravid-plakater" },
  { name: "Guddatter", url: "/collections/guddatter-plakater" },
  { name: "Gudfar", url: "/collections/gudfar-plakater" },
  { name: "Gudmor", url: "/collections/gudmor-plakater" },
  { name: "Gudsøn", url: "/collections/gudson-plakater" },
  { name: "Gudfamilie", url: "/collections/gudfamilie" },
  { name: "Hundepasser", url: "/collections/hundepasser-plakater" },
  { name: "Hustru", url: "/collections/hustru-plakater" },
  { name: "Kone", url: "/collections/kone-plakat" },
  { name: "Kammerat", url: "/collections/kammerat-plakater" },
  { name: "Kattepasser", url: "/collections/kattepasser-plakater" },
  { name: "Kusine", url: "/collections/kusine-plakater" },
  { name: "Kæreste", url: "/collections/kaereste-plakat" },
  { name: "Lillebror", url: "/collections/lillebror-plakater" },
  { name: "Lillesøster", url: "/collections/lillesoster-plakater" },
  { name: "Mand", url: "/collections/mand-plakat" },
  { name: "Morbror", url: "/collections/morbror-plakater" },
  { name: "Morfar", url: "/collections/morfar-plakat" },
  { name: "Mormor", url: "/collections/mormor-plakat" },
  { name: "Moster", url: "/collections/moster-plakat" },
  { name: "Nabo", url: "/collections/nabo-plakat" },
  { name: "Nevø", url: "/collections/nevo-plakat" },
  { name: "Niece", url: "/collections/niece" },
  { name: "Olde", url: "/collections/olde-plakat" },
  { name: "Oldebarn", url: "/collections/oldebarn-plakater" },
  { name: "Oldefar", url: "/collections/oldefar-plakater" },
  { name: "Oldemor", url: "/collections/oldemor-plakater" },
  { name: "Onkel", url: "/collections/onkel-plakat" },
  { name: "Papbror", url: "/collections/papbror-plakater" },
  { name: "Papdatter", url: "/collections/papdatter-plakater" },
  { name: "Papfar", url: "/collections/papfar-plakat" },
  { name: "Papmor", url: "/collections/papmor-plakat" },
  { name: "Papsøn", url: "/collections/papson-plakater" },
  { name: "Papsøster", url: "/collections/papsoster-plakater" },
  { name: "Partner", url: "/collections/partner-plakater" },
  { name: "Pigemor", url: "/collections/pigemor-plakater" },
  { name: "Plejedatter", url: "/collections/plejedatter-plakater" },
  { name: "Plejefar", url: "/collections/plejefar-plakater" },
  { name: "Plejemor", url: "/collections/plejemor-plakater" },
  { name: "Plejesøn", url: "/collections/plejeson-plakater" },
  { name: "Roomie", url: "/collections/roomie-plakat" },
  { name: "Småbørnsmor", url: "/collections/smabornsmor-plakater" },
  { name: "Stedbror", url: "/collections/stedbror-plakater" },
  { name: "Stedfar", url: "/collections/stedfar-plakater" },
  { name: "Stedmor", url: "/collections/stedmor-plakater" },
  { name: "Stedsøster", url: "/collections/stedsoster-plakater" },
  { name: "Storebror", url: "/collections/storebror-plakater" },
  { name: "Storesøster", url: "/collections/storesoster-plakater" },
  { name: "Svigerdatter", url: "/collections/svigerdatter-plakater" },
  { name: "Svigerfar", url: "/collections/svigerfar-plakat" },
  { name: "Svigerinde", url: "/collections/svigerinde-plakater" },
  { name: "Svigermor", url: "/collections/svigermor-plakat" },
  { name: "Svigersøn", url: "/collections/svigerson-plakater" },
  { name: "Svoger", url: "/collections/svoger-plakater" },
  { name: "Søn", url: "/collections/son-plakat" },
  { name: "Søster", url: "/collections/soster-plakat" },
  { name: "Tante", url: "/collections/tante-plakat" },
  { name: "Teenagemor", url: "/collections/teenagemor" },
  { name: "Teenager", url: "/collections/teenager-plakater" },
  { name: "Ven", url: "/collections/ven-plakater" },
  { name: "Veninde", url: "/collections/veninde-plakat" },
  { name: "Ægtemand", url: "/collections/aegtemand-plakater" },
  { name: "Ægtepar", url: "/collections/aegtepar-plakater" },
  { name: "Døtre", url: "/collections/dotre-plakater" },
  { name: "Ekstrabror", url: "/collections/ekstrabror-plakater" },
  { name: "Ekstrasøster", url: "/collections/ekstrasoster" },
  { name: "Ekstradatter", url: "/collections/ekstradatter-plakater" },
  { name: "Ekstrasøn", url: "/collections/ekstrason-plakater" },
  { name: "Ekstrabørn", url: "/collections/ekstraborn-plakater" },
  { name: "Ekstrafamilie", url: "/collections/ekstrafamilie" },
  { name: "Ekstrasøskende", url: "/collections/ekstrasoskende-plakater" },
  { name: "Familie", url: "/collections/plakater-til-familie" },
  { name: "Far & Stedfar", url: "/collections/far-stedfar-plakater" },
  { name: "Far & Bonusfar", url: "/collections/far-bonusfar-plakater" },
  { name: "Far & Ekstrafar", url: "/collections/far-ekstrafar-plakater" },
  { name: "Far & Papfar", url: "/collections/far-papfar-plakater" },
  { name: "Forældre", url: "/collections/foraeldre-plakater" },
  { name: "Forlovede", url: "/collections/forlovede-plakater" },
  { name: "Fætre", url: "/collections/faetre-plakater" },
  { name: "Halvbror", url: "/collections/halvbror-plakater" },
  { name: "Halvsøster", url: "/collections/halvsoster-plakater" },
  { name: "Halvsøskende", url: "/collections/halvsoskende-plakater" },
    { name: "Hustru", url: "/collections/hustru-plakater" },
  { name: "Kusiner", url: "/collections/kusiner-plakater" },
  { name: "Kollega", url: "/collections/gaver-til-kollega" },
  { name: "Mor & Papmor", url: "/collections/mor-papmor-plakater" },
  { name: "Mor & Stedmor", url: "/collections/mor-stedmor" },
  { name: "Mor & Bonusmor", url: "/collections/mor-bonusmor-plakater" },
  { name: "Mor & Ekstramor", url: "/collections/mor-ekstramor-plakater" },
  { name: "Mor & Far", url: "/collections/mor-far-plakater" },
  { name: "Oldeforældre", url: "/collections/oldeforaeldre-plakater" },
  { name: "Oldebørn", url: "/collections/oldeborn-plakater" },
  { name: "Par", url: "/collections/par-plakater" },
  { name: "Papsøskende", url: "/collections/papsoskende-plakater" },
  { name: "Papbørn", url: "/collections/papborn-plakater" },
  { name: "Papfamilie", url: "/collections/papfamilie-plakater" },
  { name: "Plejesøster", url: "/collections/plejesoster-plakater" },
  { name: "Plejebror", url: "/collections/plejebror-plakater" },
  { name: "Plejesøskende", url: "/collections/plejesoskende-plakater" },
  { name: "Plejebørn", url: "/collections/plejeborn-plakater" },
  { name: "Plejefamilie", url: "/collections/plejefamilie" },
  { name: "Plejebarn", url: "/collections/plejebarn-plakater" },
  { name: "Steddatter", url: "/collections/steddatter-plakater" },
  { name: "Stedsøn", url: "/collections/stedson-plakater" },
  { name: "Stedbørn", url: "/collections/stedborn-plakat" },
  { name: "Stedsøskende", url: "/collections/stedsoskende-plakater" },
  { name: "Stedfamilie", url: "/collections/stedfamilie-plakater" },
  { name: "Svigerforældre", url: "/collections/svigerforaeldre-plakater" },
  { name: "Sønner", url: "/collections/sonner-plakater" },
  { name: "Søstre", url: "/collections/sostre-plakater" },
  { name: "Søskende", url: "/collections/soskende-plakater" },
  { name: "Ægtefælle", url: "/collections/aegtefaelle-plakat" },
  { name: "Ægteskab", url: "/collections/aegteskab-plakater" },
  { name: "Svigerfamilie", url: "/collections/svigerfamilie-plakater" },

];

console.log('FAMILIES LOADED', families);
